import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="bg-transparent" data-id="element-306">
      <div className="w-full" data-id="element-307">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="w-full" data-id="element-308">
          <img src="https://cdn.magicpatterns.com/uploads/czTzyH7P8RwzmBW1Y22vZy/ChatGPT_Image_10_may_2026,_12_19_49.jpg" alt="Muchas personas aprenden Tarot, pero muy pocas aprenden a interpretarlo" className="w-full h-auto block brightness-[1.05] contrast-[1.15] saturate-[1.1]" data-id="element-309" />
        </motion.div>
      </div>
    </section>;
}